import '@google/model-viewer';
import axios from 'axios';
import $ from 'jquery';
import React, { Component } from 'react';
import { BiChevronLeftCircle, BiChevronRightCircle } from 'react-icons/all';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

export default class InfoHtmlView extends Component {
    constructor() {
        super();
        this.state = {
            html: '',
            imgList: [],
            imgIndex: 0,
            isShowImg: false,
        };
    }

    componentDidMount() {
        axios.get(this.props.filePath).then((res) => {
            var data = res.data;
            this.setState({ html: data });
            $('.info-panel-html .media .item-value img').off('click');
            $('.info-panel-html .media .item-value img').on('click', () => {
                console.log('current index ; ', $(this).attr('data-index'));
                this.setState({ isShowImg: true });
            });
            var imgList = $('.info-panel-html .media img')
                .map(function () {
                    return $(this).attr('src');
                })
                .get();
            this.setState({ imgList });
        });
    }

    render() {
        return (
            <div className="info-panel-html">
                {this.state.isShowImg && (
                    <Lightbox
                        mainSrc={this.state.imgList[this.state.imgIndex]}
                        nextSrc={
                            this.state.imgList[
                                (this.state.imgIndex + 1) %
                                    this.state.imgList.length
                            ]
                        }
                        prevSrc={
                            this.state.imgList[
                                (this.state.imgIndex +
                                    this.state.imgList.length -
                                    1) %
                                    this.state.imgList.length
                            ]
                        }
                        onCloseRequest={() =>
                            this.setState({ isShowImg: false })
                        }
                        onMovePrevRequest={() => {
                            this.setState({
                                imgIndex:
                                    (this.state.imgIndex +
                                        this.state.imgList.length -
                                        1) %
                                    this.state.imgList.length,
                            });
                        }}
                        onMoveNextRequest={() => {
                            this.setState({
                                imgIndex:
                                    (this.state.imgIndex + 1) %
                                    this.state.imgList.length,
                            });
                        }}
                    />
                )}
                <div
                    className="content"
                    dangerouslySetInnerHTML={{ __html: this.state.html }}
                />
                <div
                    className="btn btn-collapse"
                    onClick={() => {
                        this.setState({
                            isHiddenInfoPanel: !this.state.isHiddenInfoPanel,
                        });
                        this.props.onCollapse(this.state.isHiddenInfoPanel);
                    }}
                >
                    {this.state.isHiddenInfoPanel ? (
                        <BiChevronRightCircle />
                    ) : (
                        <BiChevronLeftCircle />
                    )}
                </div>
            </div>
        );
    }
}
